// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 792 ? "main" : chunkId) + "." + {"113":"5a2bf54780570680fc55","792":"b2f70f59e5e3cda26bc0"}[chunkId] + ".styles.css";
};